/**
 * Format mode label for display
 * @param {string} mode - The mode value (auto, semi_auto, manual, manual_override)
 * @returns {string} Formatted mode label
 */
export const formatModeLabel = (mode) => {
  const modeLabels = {
    'auto': 'Auto',
    'semi_auto': 'Semi-auto',
    'manual': 'Manuel',
    'manual_override': 'Manuel (override)'
  };
  
  return modeLabels[mode] || mode;
};

/**
 * Format status label for display
 * @param {string} status - The status value (draft, live, ended)
 * @returns {string} Formatted status label
 */
export const formatStatusLabel = (status) => {
  const statusLabels = {
    'draft': 'Brouillon',
    'live': 'En direct',
    'ended': 'Terminé'
  };
  
  return statusLabels[status] || status;
};

/**
 * Format playlist type for display
 * @param {string} type - The playlist type (main, backup)
 * @returns {string} Formatted type label
 */
export const formatPlaylistType = (type) => {
  const typeLabels = {
    'main': 'Principale',
    'backup': 'Secours'
  };
  
  return typeLabels[type] || type;
};
